import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import api from "../../api/api";
import logo from "../../images/SPFLLOGO.png"; // adjust path if needed
import Attachments  from "../../UserControls/Attachments/Attachments";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";
 import { getCalibrationPrintHtml } from "../dashboard/CalibrationPrintPage";

const AssetregisterPageList = () => {
  const [assets, setAssets] = useState([]);
  const [viewMode, setViewMode] = useState("card");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const userName = sessionStorage.getItem("userName");
  const companyName = sessionStorage.getItem("companyName");

  // ✅ Fetch assets from API
  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const data = await api.getAssetRegisterList(userName);
        if (data && data.Table) {
          setAssets(data.Table);
        } else {
          console.warn("Unexpected API response:", data);
        }
      } catch (error) {
        console.error("Error fetching asset register:", error);
      }
    };

    fetchAssets();
  }, [userName]);

  // ✅ Search filter
  const filteredAssets = assets.filter((asset) =>
    Object.values(asset).some(
      (val) =>
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
 const handlePrintAsset = async (assetId) => {
    
    if (!assetId) {
        console.error("Asset ID is required for printing.");
        return;
    }

    // 1. Open the new window immediately to avoid pop-up blockers
    const printWindow = window.open('', '_blank', 'width=1000,height=800,scrollbars=yes,resizable=yes');

    if (!printWindow) {
        alert("Could not open print window. Please check your browser's pop-up blocker settings.");
        return;
    }

    // Write a temporary loading message
    printWindow.document.write('<html><body><p style="text-align:center; margin-top: 50px;">Loading print data...</p></body></html>');
    printWindow.document.close();
    
    // Ensure logo path is correctly resolved
    const logoSrc = new URL(logo, window.location.href).href; 

    try {
        // 2. Fetch asset details and company details
        // This is the same API call used in Dashboard.js
        const response = await api.AssetDeatilsHTMLprint(assetId);
        const companyResponse = await api.CompanyDetailsAPI(userName);

        const assetData = {
            main: response?.Table?.[0],
            calibrations: response?.Table1 || [],
            items: response?.Table2 || [],
            spares: response?.Table3 || [],
            Table4: companyResponse?.Table || [],
        };

        if (!assetData.main) {
            // Error handling for missing data
            const errorHtml = '<html><body><p style="color:red; text-align:center; margin-top: 50px;">Failed to load asset details for printing.</p></body></html>';
            const blob = new Blob([errorHtml], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            printWindow.location.href = url;
            setTimeout(() => URL.revokeObjectURL(url), 10000);
            return;
        }

        // 3. Generate HTML content
        const htmlContent = getCalibrationPrintHtml(assetData, companyName, logoSrc);

        // 4. Use a blob URL to load the content into the new window and trigger print
        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        
        printWindow.location.href = url;
        
        // Revoke the object URL after a delay
        setTimeout(() => URL.revokeObjectURL(url), 10000); 

    } catch (error) {
        console.error("Error during print process:", error);
        
        // Display error in the new window
        const errorHtml = '<html><body><p style="color:red; text-align:center; margin-top: 50px;">An error occurred while preparing the print document.</p></body></html>';
        const blob = new Blob([errorHtml], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        printWindow.location.href = url;
        setTimeout(() => URL.revokeObjectURL(url), 10000); 
    }
  };
   
  return (
    <div className="asset-container">
   <td colSpan="2" style={{ display: "flex", alignItems: "center" ,  justifyContent: "flex-end", paddingRight: "800px", }}>
  {/* <img
    src={logo}
    alt="Company Logo"
    style={{
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "white",
      boxShadow: "0 0 4px rgba(0,0,0,0.2)",
      padding: "5px",
      marginRight: "15px", // spacing between logo and text
      objectFit: "contain",
    }}
  /> */}
  <h1
    style={{
      fontSize: "22px",
      fontWeight: "bold",
      color: "#333",
      margin: 0,
      textAlign: "left",
    }}
  >
    {companyName}
  </h1>
</td>

      <h2 className="page-title">Asset Register</h2>

      {/* Top Controls */}
      <div className="top-controls">
        <button
          className="btn-primary"
          onClick={() => navigate("/AssetRegister")}
        >
          ➕ New
        </button>

        <div className="top-right-controls">
          {/* 🔍 Search Box */}
          <div className="search-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="search-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
              />
            </svg>
            <input
              type="text"
              placeholder="Search assets..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

  <ExcelExport data={filteredAssets} fileName="AssetRegisterList" />

          {/* 🧩 View Toggle */}
          <div className="view-icons">
            <button
              onClick={() => setViewMode("card")}
              className={`icon-btn ${viewMode === "card" ? "active" : ""}`}
              title="Card View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
              </svg>
            </button>

            <button
              onClick={() => setViewMode("table")}
              className={`icon-btn ${viewMode === "table" ? "active" : ""}`}
              title="Table View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* 🔹 Card View */}
      {viewMode === "card" ? (
        <div className="grid-cards">
          {filteredAssets.map((asset) => (
            <div key={asset.AssetId} className="asset-card">
              <h3>{asset.AssetName}</h3>
              <p>
                <strong>AssetName:</strong>{" "}
                {asset.AssetName}/{asset.SerialNo}/{asset.Model}
              </p>
              <p>
                <strong>Type:</strong> {asset.AssetType}
              </p>
              <p>
                <strong>ID:</strong> {asset.AssetNo}
              </p>
              <p>
                <strong>Location:</strong> {asset.Location}
              </p>

                    <Attachments
                    mdlId="Asset_Register_Txp_Prj"
                    primeId={asset.AssetId}
                    primeName={asset.AssetName}
                    uploadedBy={sessionStorage.getItem("userName")}
                  />
<button
                              className="btn-edit" // Reusing the same styling class
                              onClick={() => handlePrintAsset(asset.AssetId)}
                              title={`Print details for ${asset.AssetName}`}
                              style={{ marginRight: '8px' }} // Add a slight margin for spacing
                            >
                              🖨️ Print
                            </button>
              <button
                className="btn-edit"
                onClick={() =>
                  navigate("/AssetRegister", {
                    state: { assetData: asset },
                  })
                }
              >
                ✏️ Edit
              </button>
            </div>
          ))}
          {filteredAssets.length === 0 && (
            <p className="mt-4 text-center text-gray-500">No assets found.</p>
          )}
        </div>
      ) : (
        // 🔹 Table View
        <div className="table-wrapper">
          <table className="asset-table">
            <thead>
              <tr>
                <th>Asset No</th>
                <th>Name</th>
                <th>Asset Type</th>
                <th>Serial No</th>
                <th>Model</th>
                <th>Project Name</th>             
                <th>EstRuning_Unit</th>
                <th>Location</th>
                <th>Specification</th>
                <th>Action</th>
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {filteredAssets.map((asset) => (
                <tr key={asset.AssetId}>
                  <td>{asset.AssetNo}</td>
                  <td>{asset.AssetName}</td>
                  <td>{asset.AssetType}</td>
                  <td>{asset.SerialNo}</td>
                  <td>{asset.Model}</td>
                  <td>{asset.ProjectName}</td>               
                  <td>{asset.EstRuning_Unit}</td>
                  <td>{asset.Location}</td>
                  <td>{asset.Specification}</td>
                  <td><button
                              className="btn-edit-small" // Reusing the same styling class
                              onClick={() => handlePrintAsset(asset.AssetId)}
                              title={`Print details for ${asset.AssetName}`}
                              style={{ marginRight: '8px' }} // Add a slight margin for spacing
                            >
                              🖨️ Print
                            </button>
                            </td>
                  <td>
                    <button
                      className="btn-edit-small"
                      onClick={() =>
                        navigate("/AssetRegister", {
                          state: { assetData: asset },
                        })
                      }
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </tr>
              ))}
              {filteredAssets.length === 0 && (
                <tr>
                  <td colSpan="11" className="py-4 text-center text-gray-500">
                    No assets found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AssetregisterPageList;

